import { FC } from 'react'

export const CheckYourEmail: FC = () => {
  return (
    <div>
      <p>
        We&apos;ve sent you a link. Confirm your email and download Mettle to
        get started.
      </p>
    </div>
  )
}
